export default "/img/consultations.png"